<template>
    <div>
        <div class="my-5 row justify-content-center d-sm-none d-block">
            <div class="p-3">
                <h1>Log in</h1>
                <div class="mb-3">
                    <label for="login" class="input-label">Usuário</label>
                    <input
                        v-model="login"
                        type="login"
                        class="form-control input-border"
                        id="login"
                    />
                </div>
                <div class="mb-3 row">
                    <label for="password" class="input-label">Senha</label>
                    <div>
                        <input
                            v-model="password"
                            type="password"
                            class="form-control input-border"
                            id="password"
                        />
                    </div>
                </div>
                <div class="container p-0">
                    <button
                        class="btn"
                        :class="isdarktheme ? 'dark_loginBtn' : 'light_loginBtn'"
                        :disabled="login.length == 0 || password.length == 0"
                        @click="doLogin"
                    >
                        Login
                    </button>
                </div>
                <div class="container mt-2 p-0">
                    <button
                        class="btn"
                        :class="isdarktheme ? 'dark_loginBtn' : 'light_loginBtn'"
                        data-bs-toggle="modal"
                        data-bs-target="#modalRegister"
                    >
                        Cadastrar
                    </button>
                </div>
            </div>
        </div>
        <div class="my-5 row justify-content-center d-none d-sm-flex">
            <div class="login-box p-3" :class="isdarktheme ? ['shadow_dark', 'bg_dark'] : ['shadow_light', 'bg-white']">
                <h1>Log in</h1>
                <div class="mb-3">
                    <label for="login" class="input-label">Usuário</label>
                    <input
                        v-model="login"
                        type="login"
                        class="form-control input-border"
                        id="login"
                    />
                </div>
                <div class="mb-3 row">
                    <label for="password" class="input-label">Senha</label>
                    <div>
                        <input
                            v-model="password"
                            type="password"
                            class="form-control input-border"
                            id="password"
                        />
                    </div>
                </div>
                <div class="container p-0">
                    <button
                        class="btn"
                        :class="isdarktheme ? 'dark_loginBtn' : 'light_loginBtn'"
                        :disabled="login.length == 0 || password.length == 0"
                        @click="doLogin"
                    >
                        Login
                    </button>
                </div>
                <div class="container mt-2 p-0">
                    <button
                        class="btn"
                        :class="isdarktheme ? 'dark_loginBtn' : 'light_loginBtn'"
                        data-bs-toggle="modal"
                        data-bs-target="#modalRegister"
                    >
                        Cadastrar
                    </button>
                </div>
            </div>
        </div>
        <div
            class="modal fade"
            id="modalRegister"
            tabindex="-1"
            aria-labelledby="modalRegisterLabel"
            aria-hidden="true"
        >
            <div class="modal-dialog font-rubik">
                <div class="modal-content" :class="isdarktheme ? 'bg_dark' : ''">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5" id="projectModalLabel">
                            Cadastro
                        </h1>
                        <button
                            type="button"
                            class="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        ></button>
                    </div>
                    <div class="modal-body">
                        <div class="mb-3">
                            <label for="login" class="input-label">Usuário</label>
                            <input
                                v-model="login"
                                type="login"
                                class="form-control"
                                id="login"
                            />
                        </div>
                        <div class="mb-3">
                            <label for="email" class="input-label">Email</label>
                            <input
                                v-model="email"
                                type="email"
                                class="form-control"
                                id="email"
                            />
                        </div>
                        <div class="mb-3 row">
                            <label for="password" class="input-label"
                                >Senha</label
                            >
                            <div>
                                <input
                                    v-model="passwordToRegister"
                                    type="password"
                                    class="form-control"
                                    id="password"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-secondary"
                            data-bs-dismiss="modal"
                        >
                            Fechar
                        </button>
                        <button
                            :disabled="!login || !passwordToRegister || !email"
                            type="button"
                            @click="doRegister"
                            class="btn btnConfirm"
                        >
                            Confirmar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import DashboardService from "@/services/DashboardService";
export default {
    data() {
        return {
            login: "",
            password: "",
            email: "",
            passwordToRegister: "",
            service: DashboardService,
        };
    },
    props: ['isdarktheme'],
    methods: {
        doLogin() {
            this.$emit('updateLoading', true)
            this.service.getLogin(this.login, this.password).then(() => {
                document.location.reload();
            });
        },
        doRegister() {
            this.$emit('updateLoading', true)
            this.service
                .register(this.login, this.email, this.passwordToRegister)
                .then((res) => {
                    this.clearRegister();
                    this.$emit('updateLoading', false)
                    if(res?.data == 1) {
                        window.alert("Cadastro efetuado com sucesso!");
                        document.location.reload();
                    } else {
                        document.location.reload();
                    }
                })
        },
        clearRegister() {
            this.login = '';
            this.email = '';
            this.password = '';
        },
    }
};
</script>
<style scoped>
.input-border {
    border: 1px solid grey;
}
.input-label {
    display: flex !important;
    font-weight: bold;
}
.login-box {
    width: 35rem;
    border-radius: 2.5%;
}
.light_loginBtn {
    width: 100%;
    color: black !important;
    border: 1px solid grey !important;
}
.light_loginBtn:hover {
    background-color: whitesmoke !important;
    cursor: pointer !important;
}
.dark_loginBtn {
    width: 100%;
    color: #ddd !important;
    border: 1px solid rgb(20, 30, 35) !important;
}
.dark_loginBtn:hover {
    background-color: rgb(40,60,70) !important;
    cursor: pointer !important;
}
.light_loginBtn:disabled {
    border: 1px solid grey !important;
}
.dark_loginBtn:disabled {
    border: 1px solid rgb(20, 30, 35) !important;
}
.shadow_dark {
    box-shadow: 3px 3px 10px rgb(20, 30, 35) !important;
}
.shadow_light {
    box-shadow: 3px 3px 10px#DFD2CE;
}
.bg_dark {
    color: white !important;
    background-color: rgb(32, 48, 56) !important;
}
.bg_dark > .modal-header, .bg_dark > .modal-footer {
    border-color: #2c3e50 !important;
}
.btnConfirm {
    color: white !important;
    border: 1px solid #44af69 !important;
    background-color: #44af69 !important;
}
</style>
